"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.individualPriceForQuantity = void 0;
const individualPriceForQuantity = (byQuantity, quantity) => {
    const startingToKey = Object.keys(byQuantity)
        .map(Number)
        .sort((a, b) => b - a)
        .find((quantityStartingTo) => quantity >= quantityStartingTo);
    return Number(byQuantity[startingToKey || 1]);
};
exports.individualPriceForQuantity = individualPriceForQuantity;
//# sourceMappingURL=individualPriceForQuantity.js.map